module.exports = __webpack_public_path__ + "img/role_1_name.ea2ce8f1.png";